// extracted by mini-css-extract-plugin
export var WelcomeOverlay = "R_cS";
export var aniBgLoading = "R_f";
export var aniSpin = "R_d";
export var bg = "R_0";
export var body = "R_bb";
export var bodyText = "R_cX";
export var close = "R_cV";
export var closeButton = "R_cY";
export var grid = "R_G";
export var head = "R_cW";
export var header = "R_C";
export var header__inner = "R_8";
export var heading = "R_D";
export var inner = "R_h";
export var scroll = "R_cT";